<template>
  <div class="submit-container">
    <div class="search-form">
      <tag-check-box label="奖项类别" :options="PRIZE_CATEGORY_EMNU" v-model="searchParams.prizeCategoryValue" />
      <tag-check-box label="奖项状态" :options="PRIZE_STATUS_EMNU" v-model="searchParams.prizeStatusValue" />
    </div>

    <div class="table">
      <a-row class="search" type="flex" justify="start">
        <a-col :span="8">
          <a-input-group compact>
            <a-select v-model="searchParams.searchType" style="display: inline-block; width: 160px">
              <a-select-option value="PROJECT_NAME"> 项目名称 </a-select-option>
            </a-select>
            <a-input style="width: calc(100% - 160px)" placeholder="请输入" />
          </a-input-group>
        </a-col>
        <a-button type="primary" style="margin-left: 8px">搜索</a-button>
      </a-row>
      <div class="tips">
        <a-alert banner>
          <div slot="message" class="message">
            1、项目报备编辑分为项目信息、中期检查、绩效评价三个不同节点的信息录入，后台配置有这个节点才可操作，请注意在提交截止时间前催促提交方及时处理；
            <br />
            2、绩效评价审核通过即为验收完成状态，发布后支队管理员/业务处室/消防员在项目查询中能通过项目信息选项查询搜索；
            <br />
            3、提交方申请退回后，可操作退回，如不进行退回，可继续当前业务流程。
          </div>
        </a-alert>
      </div>
      <div class="data">
        <list-table :list="list">
          <div slot="data1" slot-scope="{ row }" :span="12">
            <span>项目编号:</span>
            <span>{{ row.data1 }}</span>
          </div>
          <div slot="data2" slot-scope="{ row }" :span="12">
            <span>项目领域:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data3" slot-scope="{ row }" :span="12">
            <span>项目联系人:</span>
            <span>{{ row.data2 }}</span>
          </div>
          <div slot="data4" slot-scope="{ row }" :span="12">
            <span>项目负责人:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data5" slot-scope="{ row }" :span="12">
            <span>发布单位:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data6" slot-scope="{ row }" :span="12">
            <span>新建时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data7" slot-scope="{ row }" :span="12">
            <span>提交时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data8" slot-scope="{ row }" :span="12">
            <span>申请退回时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data9" slot-scope="{ row }" :span="12">
            <span>退回时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="actions" slot-scope="{ row }">
            <a-dropdown>
              <a-button>更多操作</a-button>
              <a-menu slot="overlay">
                <a-menu-item @click="openReport">编辑</a-menu-item>
                <a-menu-item @click="applyDelete">删除</a-menu-item>
                <a-menu-item @click="configuration('examine')">中期检查录入配置</a-menu-item>
                <a-menu-item @click="configuration('evaluate')">绩效评价录入配置</a-menu-item>
                <a-menu-item @click="applyIssue">发布</a-menu-item>
                <a-menu-item @click="applySoldOut">下架</a-menu-item>
                <a-menu-item @click="applySendBack">退回</a-menu-item>
              </a-menu>
            </a-dropdown>

            <a-divider type="vertical" />
            <a-button style="color: #40a9ff; border: 1px solid #40a9ff" @click="projectInfo(row)">项目详情</a-button>
            <a-divider type="vertical" />
            <a-button type="primary" @click="audit">审核</a-button>
          </div>
          <div slot="footer" slot-scope="{ row }" :span="12">
            <a-tag v-for="index in 30" :key="index" style="margin-bottom: 9px">Tag 1</a-tag>
          </div>
        </list-table>
      </div>
    </div>
    <!-- 添加/详情弹框 -->
    <j-modal
      title="项目报备编辑/新增"
      :visible="reportVisible"
      switchFullscreen
      :fullscreen="true"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
    >
      <report-modal-list></report-modal-list>
    </j-modal>
    <a-modal
      v-model="configurationVisible"
      :title="configurationType == 'examine' ? '中期检查录入配置' : '绩效评价录入配置'"
      @cancel="configurationCancel"
      @ok="configurationOk"
      width="50%"
    >
      <ApplyConfiguration :configurationType="configurationType"></ApplyConfiguration>
    </a-modal>
    <a-modal v-model="auditVisible" @cancel="auditCancel" @ok="auditOk" width="50%" title="审核">
      <AuditForm></AuditForm>
    </a-modal>
  </div>
</template>

<script>
import JModal from '@/components/jeecg/JModal/JModal'
import TagCheckBox from '../../../components/TagCheckBox'
import ListTable from '../../../components/ListTable'
import ReportModalList from './reportModalList.vue'
import ApplyConfiguration from './applyConfiguration.vue'
import AuditForm from './auditForm.vue'
const PRIZE_STATUS_EMNU = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '待提交',
    value: '1',
  },
  {
    label: '待审核',
    value: '2',
  },
  {
    label: '审核通过',
    value: '3',
  },
  {
    label: '审核驳回',
    value: '4',
  },
  {
    label: '已发布',
    value: '5',
  },
  {
    label: '已下架',
    value: '6',
  },
  {
    label: '待退回',
    value: '7',
  },
  {
    label: '已退回',
    value: 'COUNTRY_PRIZE',
  },
]
const PRIZE_CATEGORY_EMNU = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '基础研究',
    value: '基础研究',
  },
  {
    label: '重点研发',
    value: '重点研发',
  },
  {
    label: '消防管理理论与软科学',
    value: '消防管理理论与软科学',
  },
  {
    label: '应用创新',
    value: '应用创新',
  },
  {
    label: '其他',
    value: '其他',
  },
]
export default {
  components: {
    TagCheckBox,
    ListTable,
    JModal,
    ReportModalList,
    ApplyConfiguration,
    AuditForm,
  },
  data() {
    return {
      reportVisible: false,
      configurationVisible: false,
      auditVisible: false,
      configurationType: '',
      list: [
        {
          title: 'xxxxxxx',
          status: '',
          data1: '',
          data2: '',
          data3: '',
          data4: '',
          data5: '',
          data6: '',
          data7: '',
          data8: '',
          data9: '',
        },
      ],
      searchParams: {
        prizeStatusValue: [''],
        prizeCategoryValue: [''],
        searchType: 'PROJECT_NAME',
      },
      PRIZE_STATUS_EMNU,
      PRIZE_CATEGORY_EMNU,
    }
  },
  methods: {
    //项目审核
    audit() {
      this.auditVisible = true
    },
    //审核页面
    auditCancel() {
      this.auditVisible = false
    },
    //审核页面提交
    auditOk() {
      this.auditCancel()
    },
    //打开添加/详情弹框
    openReport() {
      this.reportVisible = true
    },
    //添加/详情弹框确定按钮
    handleOk() {
      this.reportVisible = false
    },
    //添加/详情弹框取消按钮
    handleCancel() {
      this.reportVisible = false
    },
    //删除项目
    applyDelete() {
      this.$confirm({
        title: '删除',
        icon:'exclamation-circle',
        content: '删除后将无法列表中查询到此条信息，请谨慎操作。',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定删除')
        },
      })
    },
    //发布项目
    applyIssue() {
      this.$confirm({
        title: '发布',
        icon:'exclamation-circle',
        content: '发布后将进入发布列表，删除/编辑/退回请先下架。',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定发布')
        },
      })
    },
    //下架项目
    applySoldOut() {
      this.$confirm({
        title: '下架',
        icon:'exclamation-circle',
        content: (
          <div>
            <p>确定下架？</p>
            <p>下架后该信息可删除/编辑/退回。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定下架')
        },
      })
    },
    //退回项目
    applySendBack() {
      this.$confirm({
        title: '退回',
        icon:'exclamation-circle',
        content: (
          <div>
            <p>确定退回？</p>
            <p>退回后该信息提交人员即可进行编辑/删除。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定退回')
        },
      })
    },
    //打开配置页面
    configuration(e) {
      if (e == 'examine') {
        //中期检查录入配置页面
        this.configurationType = 'examine'
      } else {
        //绩效评价录入配置页面
        this.configurationType = 'evaluate'
      }
      this.configurationVisible = true
    },
    //关闭配置页面
    configurationCancel() {
      this.configurationVisible = false
    },
    //配置页面提交
    configurationOk() {
      this.configurationCancel()
    },
    //打开项目详情
    projectInfo(e){
      console.log(e);
      this.$router.push(`/project/filing/preview/${e}`)
    }
  },
}
</script>

<style lang="less" scoped>
.submit-container {
  background: #f0f2f5;
  .search-form {
    padding: 0 20px 20px;
    background: #fff;
  }
  .table {
    margin-top: 16px;
    background: #fff;
  }
  .search {
    padding: 24px 16px;
    border-bottom: 1px #f0f0f0 solid;
  }
  .tips {
    margin: 14px 15px;
    .message {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      font-weight: 400;
      line-height: 1.6;
      margin-left: 10px;
    }
  }
  .actions {
    margin: 14px 15px 0;
  }
  .data {
    padding: 0 14px 15px;
  }
}
</style>